import { CustomField } from '@work4all/models/lib/Classes/CustomField.entity';

export const CUSTOM_FIELDS_DATA: CustomField = {
  key: null,
  value: null,
};
